import React, { useState } from 'react';
import { TextField } from '@material-ui/core';
import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import globalUseStyles from '../../../globalClasses';

interface ReactHookFormTextFieldProps {
  name: string;
  label: string;
  required?: boolean;
  defaultValue?: string;
  disabled?: boolean;
  type?: string;
  control: Control;
  preventSpecialCharacters?: boolean;
  checkMarkingBounds?: (jewelryType: string, fieldName: string, currentValue: number) => boolean;
  jewelryType?: string;
}

const ReactHookFormTextField: React.FC<ReactHookFormTextFieldProps> = ({
  name,
  label,
  control,
  required = false,
  disabled = false,
  defaultValue = '',
  type,
  preventSpecialCharacters = false,
  checkMarkingBounds,
  jewelryType,
}) => {
  const globalStyles = globalUseStyles();
  const [outOfBounds, setOutOfBounds] = useState(false);
  return (
    <Controller
      render={({ field, fieldState, formState }) => (
        <TextField
          required={required}
          label={label}
          id={`${label.replaceAll(' ', '-').toLowerCase()}-text-select`}
          variant="outlined"
          disabled={disabled}
          type={type}
          fullWidth
          error={!!fieldState.error || (formState.isSubmitted && required && !fieldState.isDirty && defaultValue === '')}
          // library randomly turned error into an any type, but the component still functions the same
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          helperText={fieldState.error ? fieldState?.error?.message : null}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...field}
          inputProps={{ className: outOfBounds ? globalStyles.styleOutOfBounds : '', pattern: preventSpecialCharacters ? '^[a-zA-Z0-9]*$' : '[\\s\\S]*' }}
          onChange={(event) => {
            field.onChange(event);
            if (jewelryType) {
              const isOutOfBounds = checkMarkingBounds?.(jewelryType, label, Number.parseFloat(event.target.value));
              setOutOfBounds(isOutOfBounds || false);
            }
          }}
        />
      )}
      control={control}
      name={name}
      defaultValue={defaultValue}
      shouldUnregister
      rules={{
        required: {
          value: required,
          message: `${label} is required`,
        },
        pattern: {
          message: 'No Special Characters',
          value: preventSpecialCharacters ? /^[a-zA-Z0-9]*$/g : /[\s\S]*/,
        },
      }}
    />
  );
};
export default ReactHookFormTextField;
